// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2NXAY","label":"Category_label__21UXe","content":"Category_content__1IydN","header":"Category_header__3_aM0","location":"Category_location__2tRkP"};